import React, { useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { API_BASE_URL } from "../../../apiConfig";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import LocalGroceryStoreIcon from "@mui/icons-material/LocalGroceryStore";
import LinkIcon from "@mui/icons-material/Link";
import { refreshTokenIfNeeded } from "../refreshTokenIfNeeded";
import { useNavigate } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  borderRadius: "5px",
  boxShadow: 24,
  p: 0.5,
};

const StyledCard = styled(Card)(({ theme }) => ({
  boxShadow: theme.shadows[5],
  borderRadius: theme.shape.borderRadius,
}));

export default function CouponModal({ id, onClose }) {
  const [couponData, setCouponData] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setError(null);
      try {
        const token = localStorage.getItem("token");

        if (!token) {
          throw new Error("Token not available. Please log in.");
        }

        const response = await axios.get(`${API_BASE_URL}Coupon/Find/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setCouponData({
          id: response.data.id,
          couponTitle: response.data.couponTitle,
          couponDescription: response.data.couponDescription,
          couponCode: response.data.couponCode,
          affiliatelink: response.data.affiliatelink,
        });
      } catch (err) {
        if (err.response?.status === 401) {
          try {
            const newToken = await refreshTokenIfNeeded();

            if (!newToken) {
              return navigate("/", { replace: true });
            }

            // إعادة الطلب بالتوكن الجديد
            const response = await axios.get(
              `${API_BASE_URL}Coupon/Find/${id}`,
              {
                headers: {
                  Authorization: `Bearer ${newToken}`,
                },
              },
            );

            setCouponData({
              id: response.data.id,
              couponTitle: response.data.couponTitle,
              couponDescription: response.data.couponDescription,
              couponCode: response.data.couponCode,
              affiliatelink: response.data.affiliatelink,
            });
          } catch (retryError) {
            setError("Retry failed: " + retryError.message);
          }
        } else {
          setError("Failed to fetch user data");
        }
      }
    };

    fetchData();
  }, [id]);

  return (
    <Modal
      dir="rtl"
      open={true}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <StyledCard>
          <CardHeader
            dir="ltr"
            action={
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            }
            sx={{ textAlign: "center" }}
          />

          <CardContent sx={{ textAlign: "right", mt: 2 }}>
            {error ? (
              <Typography color="error">{error}</Typography>
            ) : (
              <>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <LocalGroceryStoreIcon sx={{ mr: 1, color: "green" }} />
                  <Typography variant="body1" sx={{ fontSize: "1.1rem" }}>
                    <strong>عنوان الكوبون:</strong>{" "}
                    <strong>{couponData?.couponTitle || "N/A"}</strong>
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <DriveFileRenameOutlineIcon sx={{ mr: 1, color: "blue" }} />
                  <Typography variant="body1" sx={{ fontSize: "1.1rem" }}>
                    <strong>الكوبون:</strong>{" "}
                    <strong>{couponData?.couponCode || "N/A"}</strong>
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <LinkIcon sx={{ mr: 1, color: "green" }} />
                  <Typography variant="body1" sx={{ fontSize: "1.1rem" }}>
                    <strong>رابط افلييت:</strong>{" "}
                    <strong>{couponData?.affiliatelink || "N/A"}</strong>
                  </Typography>
                </Box>
              </>
            )}
          </CardContent>
        </StyledCard>
      </Box>
    </Modal>
  );
}
